export const FIELDS = {
  TITLE: 'title',
  POSTER: 'poster',
  START_DATE_TIME: 'startDateTime',
  END_DATE_TIME: 'endDateTime',
  DESCRIPTION: 'description',
  LOCATION: 'location',
  CATEGORIES: 'categories',
  OWNER: 'owner',
};

export const POSTER_FIELDS = {
  FILE: 'file',
  ID: 'id',
  KEY: 'key',
  NAME: 'name',
  SIZE: 'size',
  URL: 'url',
};

export const POSTER_PATH = 'posters';



// WEBPACK FOOTER //
// ./src/constants/eventForm.js